import { useState } from 'react';
import { DefaultCarouselView } from '../../../../lib/api/custom-page.types';
import { ITEMS_IN_SINGLE_ROW } from '../../../../lib/constants';
import { getExpandButtonText } from '../../SessionWrapper/helpers';

interface IUseTrackCollapseArgs {
  track: string;
  defaultCarouselView?: DefaultCarouselView;
  nonFeaturedCount: number;
}

interface IUseTrackCollapseResult {
  isCarouselView: boolean;
  isTrack: boolean;
  expandButtonText: string;
  shouldRenderExpandButton: boolean;
  shouldRenderTrackExpandButton: boolean;
  toggle: () => void;
}

const isInitiallyCollapsed = (defaultCarouselView?: DefaultCarouselView): boolean => {
  return defaultCarouselView === DefaultCarouselView.Collapsed;
};

export const useTrackCollapse = ({
  track,
  defaultCarouselView,
  nonFeaturedCount,
}: IUseTrackCollapseArgs): IUseTrackCollapseResult => {
  const [isCarouselView, setIsCarouselView] = useState(() => isInitiallyCollapsed(defaultCarouselView));

  const toggle = (): void => {
    setIsCarouselView(value => !value);
  };

  const expandButtonText = getExpandButtonText(isCarouselView);
  const shouldRenderExpandButton = nonFeaturedCount > ITEMS_IN_SINGLE_ROW;
  const isTrack = Boolean(track);
  const shouldRenderTrackExpandButton = isTrack && shouldRenderExpandButton;

  return {
    isCarouselView,
    isTrack,
    expandButtonText,
    shouldRenderExpandButton,
    shouldRenderTrackExpandButton,
    toggle,
  };
};
